<div  class="idcard idcard__{{idVerificationStatus === 'Passed'? 'passed': 'failed'}}" >
  <div class="state-icon-container">
    @if (idVerificationStatus === 'Passed') {
      <img
        src="../../../assets/icons/check_circle-icon.svg"
        alt="green check circle"
        />
    }
    @if (idVerificationStatus === 'Failed') {
      <img
        src="../../../assets/icons/error-icon.svg"
        alt="error exclaimation mark"
        />
    }
    @if (idVerificationStatus === 'Review') {
      <img
        src="../../../assets/icons/error-icon.svg"
        alt="error exclaimation mark"
        />
    }
  </div>
  <div class="card-body">
    <div class="status-result" data-private>Credential Analysis: {{ idVerificationStatus }}</div>
  </div>
</div>